module.exports = __webpack_public_path__ + "img/292.0023ab71.gif";